var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCarGreen20X20 = function SvgCarGreen20X20(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.833 15a.834.834 0 1 1-1.668 0 .834.834 0 0 1 1.668 0Zm-5.834-2.5H3.333l.013-8.333h9.153l-.013 8.333H9.999ZM5.833 15a.834.834 0 1 1-1.668 0 .834.834 0 0 1 1.668 0Zm10.833-4.6v2.1h-2.5V8.4l2.5 2Zm1.354-1.05-3.854-3.084v-2.1c0-.919-.678-1.666-1.51-1.666h-9.48c-.832 0-1.51.748-1.51 1.667V12.5c0 .727.428 1.34 1.018 1.568a2.476 2.476 0 0 0-.185.932c0 1.378 1.122 2.5 2.5 2.5 1.379 0 2.5-1.122 2.5-2.5 0-.294-.06-.572-.154-.833h5.308A2.45 2.45 0 0 0 12.5 15c0 1.378 1.122 2.5 2.5 2.5 1.379 0 2.5-1.122 2.5-2.5 0-.294-.06-.572-.154-.833h.154c.461 0 .834-.373.834-.834V10a.834.834 0 0 0-.313-.65Z",
    fill: "#008545"
  })));
};
export default SvgCarGreen20X20;